module.exports = require("@mantine/core");